export default "__VITE_ASSET__Bavibu1i__"